import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/golf-club-storage.jpg'),
    alt: 'golf club storage page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'golf club storage page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Effortless <span>and Affordable</span> <span>Golf Club Storage Solutions</span>',
  description:
    'Discover ShipAndStorage’s premium Golf Club Storage services, offering convenience, security, and year-round accessibility for your golf equipment.',
  image: {
    url: '/images/v2/pages/main-pages/golf-club-storage/hero-image.jpg',
    alt: 'Effortless and Affordable Golf Club Storage Solutions'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Store Your Golf Clubs' }
}

export const whyWeSectionContent = {
  title: 'How to Store Your Golf Clubs with ShipAndStorage',
  description: 'Storing your golf clubs is simple and efficient with our streamlined process.',
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Book Now' },

  cards: [
    {
      id: 1,
      title: 'Create an Account',
      description:
        'Sign up on our platform and access tailored Golf Club Storage solutions designed to meet your needs.',
      image: {
        src: '/images/v2/pages/main-pages/golf-club-storage/create-an-account.png',
        alt: 'Create an Account'
      }
    },
    {
      id: 2,
      title: 'Prepare Your Equipment',
      description: 'Clean and securely pack your clubs to ensure their protection during transit.',
      image: {
        src: '/images/v2/pages/main-pages/golf-club-storage/prepare-your-equipment.png',
        alt: 'Prepare Your Equipment'
      }
    },
    {
      id: 3,
      title: 'Schedule Pickup or Drop-Off',
      description: 'Choose the most convenient option to deliver your golf clubs to our facility.',
      image: {
        src: '/images/v2/pages/main-pages/golf-club-storage/schedule-pickup-or-drop-off.png',
        alt: 'Schedule Pickup or Drop-Off'
      }
    },
    {
      id: 4,
      title: 'Relax and Access Anytime',
      description: 'Your golf clubs are stored safely and remain accessible whenever you need them.',
      image: {
        src: '/images/v2/pages/main-pages/golf-club-storage/relax-and-access-anytime.png',
        alt: 'Relax and Access Anytime'
      }
    }
  ]
}

export const serviceTipsSectionContent = {
  title: 'Why Proper Golf Club Storage Matters',
  description:
    'Ensuring your golf clubs are stored correctly is essential for maintaining their condition and longevity.',

  cards: [
    {
      id: 1,
      title: 'Maintain Equipment',
      description: "Proper storage is crucial to maintain your golf clubs' performance and extend their lifespan.",
      image: {
        src: '/images/v2/pages/main-pages/golf-club-storage/maintain-equipment.png',
        alt: 'Maintain Equipment'
      }
    },
    {
      id: 2,
      title: 'Prevent Damage',
      description:
        'Prevent damage from improper handling or environmental factors by ensuring your clubs are stored safely.',
      image: {
        src: '/images/v2/pages/main-pages/golf-club-storage/prevent-damage.png',
        alt: 'Prevent Damage'
      }
    },
    {
      id: 3,
      title: 'Optimize Space',
      description:
        'Utilize dedicated storage solutions to optimize space and declutter your home or garage effectively.',
      image: {
        src: '/images/v2/pages/main-pages/golf-club-storage/optimize-space.png',
        alt: 'Optimize Space'
      }
    },
    {
      id: 4,
      title: 'Seasonal Storage',
      description:
        'Safely store your golf clubs during the off-season for convenience and to prevent unnecessary wear.',
      image: {
        src: '/images/v2/pages/main-pages/golf-club-storage/seasonal-storage.png',
        alt: 'Seasonal Storage'
      }
    },
    {
      id: 5,
      title: 'Easy Retrieval',
      description:
        'Retrieve your clubs quickly without hassle by keeping everything organized and easily accessible when needed.',
      image: {
        src: '/images/v2/pages/main-pages/golf-club-storage/easy-retrieval.png',
        alt: 'Easy Retrieval'
      }
    },
    {
      id: 6,
      title: 'Protect Your Gear',
      description:
        'Protect your investment by following best practices for golf club storage to enjoy your next game worry-free.',
      image: {
        src: '/images/v2/pages/main-pages/golf-club-storage/protect-your-gear.png',
        alt: 'Protect Your Gear'
      }
    }
  ]
}

export const typesOfGolfClubsSectionContent = {
  title: 'Types of Golf Clubs We Store',
  description: 'We cater to golf enthusiasts by offering storage solutions for various golf equipment.',

  cards: [
    {
      id: 1,
      title: 'Golf Clubs',
      description: 'Protect your golf clubs from damage with our secure and climate-controlled storage.',
      image: {
        src: '/images/v2/pages/main-pages/golf-club-storage/golf-clubs.png',
        alt: 'Golf Clubs'
      }
    },
    {
      id: 2,
      title: 'Golf Bags',
      description: 'Keep your golf bags in top condition, ensuring they are ready for your next adventure.',
      image: {
        src: '/images/v2/pages/main-pages/golf-club-storage/golf-bags.png',
        alt: 'Golf Bags'
      }
    },
    {
      id: 3,
      title: 'Accessories',
      description: 'Store golf shoes, gloves, tees, and other essential accessories safely and efficiently.',
      image: {
        src: '/images/v2/pages/main-pages/golf-club-storage/accessories.png',
        alt: 'Accessories'
      }
    }
  ]
}

export const whyChooseUsSectionContent = {
  title: 'Why Choose Us for Your Golf Club Storage?',

  cards: [
    {
      id: 1,
      title: 'Flexible Storage Options',
      description:
        'Pay only for what you need with transparent pricing and choose between short-term or long-term plans without hidden fees.',
      image: {
        src: '/images/v2/pages/main-pages/golf-club-storage/flexible-storage-options.png',
        alt: 'Flexible Storage Options'
      }
    },
    {
      id: 2,
      title: 'Secure Facilities',
      description:
        'Benefit from climate-controlled storage that prevents damage, secured by 24/7 monitoring and advanced security systems.',
      image: {
        src: '/images/v2/pages/main-pages/golf-club-storage/secure-facilities.png',
        alt: 'Secure Facilities'
      }
    },
    {
      id: 3,
      title: 'Convenient Accessibility',
      description:
        'Easily retrieve your golf clubs with flexible options, plus enjoy shipping services that deliver directly to your home.',
      image: {
        src: '/images/v2/pages/main-pages/golf-club-storage/convenient-accessibility.png',
        alt: 'Convenient Accessibility'
      }
    },
    {
      id: 4,
      title: 'Expert Support',
      description:
        'Get personalized assistance for oversized or delicate golf equipment and receive professional packing tips for your needs.',
      image: {
        src: '/images/v2/pages/main-pages/golf-club-storage/expert-support.png',
        alt: 'Expert Support'
      }
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Convenient Golf Club Storage Solutions',
  description:
    'Store your golf clubs with us for a seamless and stress-free experience. Ship your clubs and bags to our secure facility and enjoy a clutter-free home.',
  image: {
    src: '/images/v2/pages/main-pages/golf-club-storage/convenient-golf-club-storage-solutions.png',
    alt: 'Convenient Golf Club Storage Solutions'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Store With Us' }
}

export const faqSectionContent = {
  title: 'Frequently Asked Questions',

  questions: [
    {
      id: 1,
      question: 'What types of golf equipment can I store?',
      answer: 'We accommodate a wide range of golf equipment, including golf clubs, bags, accessories, and more.'
    },
    {
      id: 2,
      question: 'Is my equipment safe in storage?',
      answer: 'Yes, our facilities are climate-controlled and monitored 24/7 to ensure the highest level of security.'
    },
    {
      id: 3,
      question: 'Can I access my equipment anytime?',
      answer: 'Absolutely! Your equipment remains accessible whenever you need it.'
    },
    {
      id: 4,
      question: 'Do you offer pickup and delivery?',
      answer: 'Yes, we provide convenient pickup and delivery options to make storage hassle-free.'
    },
    {
      id: 5,
      question: 'How much does golf club storage cost?',
      answer: 'Pricing varies based on the duration and type of equipment stored. Contact us for a personalized quote.'
    }
  ]
}
